import DishDetails from "./DishDetails";
import {
  DishDetailsConfigContext,
  DishDetailsConfigProvider,
} from "./DishDetailsConfigContext";
import useDishDetailsConfig from "./hooks/useDishDetailsConfig";
import {DishDetailsConfig} from "./interfaces";

export default DishDetails;
export type {DishDetailsConfig};
export {
  DishDetailsConfigProvider,
  DishDetailsConfigContext,
  useDishDetailsConfig,
};
